const vP18243 = require("./364.js");
function f2172(p18244) {
  this.genPoly = undefined;
  this.degree = p18244;
  if (this.degree) {
    this.initialize(this.degree);
  }
}
f2172.prototype.initialize = function (p18245) {
  this.degree = p18245;
  this.genPoly = vP18243.generateECPolynomial(this.degree);
};
f2172.prototype.encode = function (p18246) {
  if (!this.genPoly) {
    throw new Error("Encoder not initialized");
  }
  const v14036 = new Uint8Array(p18246.length + this.degree);
  v14036.set(p18246);
  const v14037 = vP18243.mod(v14036, this.genPoly);
  const v14038 = this.degree - v14037.length;
  if (v14038 > 0) {
    const v14039 = new Uint8Array(this.degree);
    v14039.set(v14037, v14038);
    return v14039;
  }
  return v14037;
};
module.exports = f2172;